export const enum LabelFormat {
    FullName = 'fullName',
    ShortFullName = 'shortFullName',
    BirthDay = 'birthDay',
    RecordId = 'recordId',
    Phone = 'phone',
}

export const CREATE_PATIENT_VALUE = 'create_new_patient';
